document.addEventListener("DOMContentLoaded", function () {
    const barScrollContainer = document.getElementById("partner-container");

    if (!barScrollContainer) {
        return;
    }

    const scrollContentContainer = barScrollContainer.querySelector(".scroller-content");

    if (!scrollContentContainer) {
        return;
    }

    const items = Array.from(scrollContentContainer.children); // Obtener todos los ítems
    let scrollAmount = 0;
    let isPaused = false; // Bandera para controlar el estado de pausa
    let animationFrameId = null; // Para almacenar el ID de requestAnimationFrame

    // Clonar los elementos para crear un efecto continuo
    items.forEach((item) => {
        const clone = item.cloneNode(true);
        scrollContentContainer.appendChild(clone);
    });

    // Función para mover el contenedor hacia la izquierda
    function scrollContent() {
        if (isPaused) {
            // Si está pausado, no actualizamos el scrollAmount ni llamamos a requestAnimationFrame
            return;
        }

        scrollAmount -= 0.4; // Controla la velocidad del scroll (ajusta este valor)
        if (Math.abs(scrollAmount) >= scrollContentContainer.scrollWidth / 2) {
            scrollAmount = 0; // Reinicia el scroll cuando llega al final
        }
        scrollContentContainer.style.transform = `translateX(${scrollAmount}px)`; // Mueve el contenedor
        animationFrameId = requestAnimationFrame(scrollContent); // Llama a la función de nuevo
    }

    // Iniciar la animación
    animationFrameId = requestAnimationFrame(scrollContent);

    // Agregar eventos de hover a los elementos hijos
    const partnerItems = scrollContentContainer.querySelectorAll(".partner");
    partnerItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            isPaused = true; // Pausar la animación
            cancelAnimationFrame(animationFrameId); // Cancelar el frame actual
        });

        item.addEventListener("mouseleave", () => {
            if (isPaused) {
                isPaused = false; // Reanudar la animación
                animationFrameId = requestAnimationFrame(scrollContent); // Reiniciar la animación
            }
        });
    });
});
